import MonitoringQueueEntrySearchDetailsForm from './MonitoringQueueEntrySearchDetailsForm';

export default MonitoringQueueEntrySearchDetailsForm;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-details-form/index.js